import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { FormatDetailModel } from 'src/app/models/formats/format-detail.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormatDetailService {

  constructor(private _httpClient: HttpClient) { }

  createFormatDetail(formatDetailContract: FormatDetailModel): Observable<FormatDetailModel> {
    return this._httpClient.post<FormatDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.CreateFormatDetail}`,
      formatDetailContract);
  }

  deleteFormatDetail(formatDetailId: number): Observable<FormatDetailModel> {
    return this._httpClient.delete<FormatDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.DeleteFormatDetail}/${formatDetailId}`);
  }

  deleteSomeDetails(formatDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.DeleteSomeDetails}`,
      formatDetailIds);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.ExportDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllFormatDetail(): Observable<Array<FormatDetailModel>> {
    return this._httpClient.get<Array<FormatDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.GetAllFormatDetail}`)
  }

  getAllFormatDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.GetAllFormatDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.GetColumnsForCaptureTableAsync}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.GetColumnsForDetailConsultationAsync}`);
  }

  getFormatDetailByFormatAndName(formatId: number, name: string): Observable<FormatDetailModel> {
    const itemFilterResponse = new ItemFilterModel("name", null, formatId, "");
    itemFilterResponse.wildcard = name;
    return this._httpClient.post<FormatDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.GetFormatDetailByFormatAndName}`, itemFilterResponse);
  }

  getFormatDetailById(formatDetailId: number | null): Observable<FormatDetailModel> {
    return this._httpClient.get<FormatDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.GetByIdAsync}/${formatDetailId}`)
  }

  getFormatDetailsByFormatId(formatId: number): Observable<Array<FormatDetailModel>> {
    return this._httpClient.get<Array<FormatDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.GetFormatDetailsByFormatId}/${formatId}`)
  }

  getFormatDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], formatId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant).set('formatId', formatId);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.GetFormatDetailsForCaptureTableAsync}`,
      filters, { params: params }
    );
  }

  updateFormatDetail(formatDetailContract: FormatDetailModel): Observable<FormatDetailModel> {
    return this._httpClient.put<FormatDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.UpdateFormatDetail}`,
      formatDetailContract);
  }

  updateRangeFormatDetail(formatDetailContracts: Array<FormatDetailModel>): Observable<FormatModel> {
    return this._httpClient.put<FormatModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.formatDetail.UpdateRangeFormatDetail}`,
      formatDetailContracts);
  }
}
